import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json'
    })
  };

@Injectable({
  providedIn: 'root'
})


export class HttpService {

  httpUrl = './save_user_data.php';

  constructor(private http: HttpClient) {
  }


  postContactForm(data: JSON) {
    this.http.post(this.httpUrl, data, httpOptions)
      .subscribe(
        data => console.log(data)
      );
  }
}
